import app from '@frontend/application-container';
import { defaults } from '@frontend/Settings';
import triangles from '@frontend/state/triangles';
import { Length } from '@frontend/Units';
import { SettingsEntry } from '../settings-entry';
import { img, Button } from '@phi/components';
import { h } from 'vue';
import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/reset_settings.svg';

export function reset_settings() {
    Object.assign(app.settings, defaults);
    app.settings.display_units = app.state.display_units = app.state.onshape_default_length ?? Length.cm;
    app.state.interrupt_drag_at_failed_consistency_checks = false;
    app.state.always_run_consistency_checks_on_vertices = true;
    app.state.always_run_consistency_checks_on_rest = false;
    triangles(app.settings.triangles);
}

export function ResetSettings() {
    return SettingsEntry(
        'Reset settings',

        'Reset all settings to the defaults.',

        img(icon, 'Reset settings'),

        h(Button, {
            variant: 'primary',
            onClick: reset_settings,
        }, () => 'Reset'),
    );
}
